import { IsNotEmpty, IsString, ValidateIf } from 'class-validator';
import { Mapper } from '../../../common/ddd/mapper.base';
import { IOrgSentimentReportEnum } from '../../../common/enum/org-sentiment/org-sentiment.enum';
import { ChallengeSentimentEntity } from '../../../core/domain/entities/challenge-insights/challenge-sentiment.entity';
import { AccountMetricInsightsMetricType } from '../../../interface/dtos/challenge-insights/account-metrics-insights-metric-type.enum';
import { ListAccountMetricsInsightsSummariesResponse } from '../../../interface/dtos/challenge-insights/list-account-metrics-insights-summary.result.dto';

export class ChallengeSentimentPersistenceResponse {
  @ValidateIf((o) => o[IOrgSentimentReportEnum.Count] === null)
  @IsString()
  [IOrgSentimentReportEnum.TotalScore]: string | null;

  @ValidateIf((o) => o[IOrgSentimentReportEnum.TotalScore] === null)
  @IsString()
  [IOrgSentimentReportEnum.Count]: string | null;

  @IsNotEmpty()
  [IOrgSentimentReportEnum.DayCount]: string;

  @IsNotEmpty()
  [IOrgSentimentReportEnum.UserId]: string;

  @IsNotEmpty()
  [IOrgSentimentReportEnum.LocalDate]: string;
}

export class ChallengeSentimentMapper
  implements
    Omit<Mapper<ChallengeSentimentEntity, any>, 'toPersistence' | 'toResponse'>
{
  toDomain(
    record: ChallengeSentimentPersistenceResponse
  ): ChallengeSentimentEntity {
    return ChallengeSentimentMapper.toDomain(record);
  }

  static toDomain(
    record: ChallengeSentimentPersistenceResponse
  ): ChallengeSentimentEntity {
    const entity = ChallengeSentimentEntity.create({
      value: record[IOrgSentimentReportEnum.TotalScore]
        ? Number(record[IOrgSentimentReportEnum.TotalScore])
        : Number(record[IOrgSentimentReportEnum.Count]),
      count: Number(record[IOrgSentimentReportEnum.DayCount]),
      date: new Date(record[IOrgSentimentReportEnum.LocalDate]),
    });
    entity.setUserId(record[IOrgSentimentReportEnum.UserId]);
    return entity;
  }

  toResponse(
    entity: ChallengeSentimentEntity
  ): ListAccountMetricsInsightsSummariesResponse {
    return ChallengeSentimentMapper.toResponse(entity);
  }

  static toResponse(
    entity: ChallengeSentimentEntity
  ): ListAccountMetricsInsightsSummariesResponse {
    return {
      value: Number(entity.value.toFixed(1)),
      formattedValue: `${entity.value.toFixed(1)}`,
      average: Number(entity.avg.toFixed(1)),
      formattedAverage: `${entity.avg.toFixed(1)}`,
      metricType: AccountMetricInsightsMetricType.Sentiment,
      deviation: '',
      averageDeviation: '',
    };
  }
}
